import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import ServicesPage from "@/pages/ServicesPage";
import CoursesPage from "@/pages/CoursesPage";
import SkillsAcademyPage from "@/pages/SkillsAcademyPage";
import OnDemandPage from "@/pages/OnDemandPage";
import GalleryPage from "@/pages/GalleryPage";
import ContactPage from "@/pages/ContactPage";
import ClientIntakeForm from "@/pages/ClientIntakeForm";
import SpecialCoursesPage from "@/pages/SpecialCoursesPage";
import BookingPage from "@/pages/BookingPage";
import AlumniDirectoryPage from "@/pages/AlumniDirectoryPage";
import AlumniApplyPage from "@/pages/AlumniApplyPage";
import AlumniProfilePage from "@/pages/AlumniProfilePage";
import AlumniAdminPage from "@/pages/AlumniAdminPage";
import EventsPage from "@/pages/EventsPage";
import GiftCardsPage from "@/pages/GiftCardsPage";
import GiftCardPolicyPage from "@/pages/GiftCardPolicyPage";
import AdminDashboardPage from "@/pages/AdminDashboardPage";
import WeddingPackagePage from "@/pages/WeddingPackagePage";
import LoyaltyCardPage from "@/pages/LoyaltyCardPage";

function App() {
  return (
    <div className="min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/courses" element={<CoursesPage />} />
            <Route path="/skills-academy" element={<SkillsAcademyPage />} />
            <Route path="/on-demand" element={<OnDemandPage />} />
            <Route path="/gallery" element={<GalleryPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/intake-form" element={<ClientIntakeForm />} />
            <Route path="/special-courses" element={<SpecialCoursesPage />} />
            <Route path="/book" element={<BookingPage />} />
            <Route path="/alumni" element={<AlumniDirectoryPage />} />
            <Route path="/alumni/apply" element={<AlumniApplyPage />} />
            <Route path="/alumni/:id" element={<AlumniProfilePage />} />
            <Route path="/alumni-admin" element={<AlumniAdminPage />} />
            <Route path="/events" element={<EventsPage />} />
            <Route path="/gift-cards" element={<GiftCardsPage />} />
            <Route path="/gift-card-policy" element={<GiftCardPolicyPage />} />
            <Route path="/admin" element={<AdminDashboardPage />} />
            <Route path="/wedding" element={<WeddingPackagePage />} />
            <Route path="/loyalty" element={<LoyaltyCardPage />} />
          </Routes>
        </main>
        <Footer />
        <Toaster 
          position="top-right" 
          toastOptions={{
            style: {
              background: '#121212',
              color: '#FAFAFA',
              border: '1px solid #C5A059',
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
